import { CheckIcon } from "./Icons";
import type { Page } from "../types";

export function FinalCTA({ onNavigate }: { onNavigate: (p: Page) => void }) {
    return (
        <section className="py-12 px-6 bg-gradient-to-br from-slate-900 to-[#1e3a5f] text-white text-center" id="contact">
            <div className="max-w-[1200px] mx-auto">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-white leading-[1.2] tracking-tight mb-4">
                    Passez au digital.<br />Vos clients vous attendent en ligne.
                </h2>
                <p className="text-slate-400 text-[1.15rem] mb-8 max-w-[600px] mx-auto">
                    Rejoignez les food trucks, camion pizzas et snacks qui ont simplifié leur quotidien avec la commande en ligne.
                </p>
                <button onClick={() => onNavigate("contact")} className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-[1.05rem] font-bold bg-white text-slate-900 shadow-md hover:translate-y-[-2px] hover:shadow-lg transition-all cursor-pointer border-none">
                    Démarrer pour 180€/an — tout inclus →
                </button>
                <div className="flex justify-center gap-8 mt-8 text-[0.9rem] text-slate-400 flex-wrap max-sm:flex-col max-sm:items-center max-sm:gap-3">
                    <span className="flex items-center gap-1.5"><CheckIcon size={16} /> 0% de commission</span>
                    <span className="flex items-center gap-1.5"><CheckIcon size={16} /> Opérationnel en 48h</span>
                    <span className="flex items-center gap-1.5"><CheckIcon size={16} /> Tout inclus</span>
                    <span className="flex items-center gap-1.5"><CheckIcon size={16} /> Support inclus</span>
                </div>
            </div>
        </section>
    );
}
